<template>
    <div>
        <v-container fluid class="pa-0">
          <div>
            <video-background
                :src="require('@/assets/enviro-short.mp4')"
                style="max-height: 600px; height: 100vh;"
            >
              <div class="d-flex fill-height flex-column justify-center align-content-center">
                <h1 class="h1 h1-overlay white--text text-center">Its our world<br>
                It's our lost property<br>
                Let's look after it</h1>
              </div>

            </video-background>
          </div>

            <v-container class="contain-width" style="margin-top: -120px">
                <v-row>
                    <v-col
                            cols="12"
                    >
                        <v-card
                                class="mx-auto product-card mt-xs-3 mt-sm-6 mt-md-16"
                                outlined
                        >

                            <v-card-text>

                                <p class="text-h6">With more than 3000 items lost per person during a lifetime and around 10 minutes a day spent searching for lost property, <strong><i>findmykit</i></strong> is a solution that circumvents the requirement to replace lost possessions. Whilst the financial aspect is one of our priorities when it comes to having to buy replacement items, so too is the cost on the environment.</p>
                                <p class="text-h5 primary--text"><strong><i>Findmykit</i></strong> have created a product that not only helps to solve the global lost property problem, but also a product and service that positively reduces the impact on our planet.</p>
                            </v-card-text>
                        </v-card>
                    </v-col>
                </v-row>
                <v-row>
                  <v-col
                      cols="12"
                      sm="12"
                      md="4">
                    <v-card class="product-card equal-height-card">
                      <div class="d-flex flex-no-wrap justify-space-between">
                        <v-card-title class="headline primary--text">Non-plastic tags</v-card-title>
                        <div>
                          <v-img :src="require('@/assets/square-key-tags.jpg')" width="80px" height="80px" style="border-top-right-radius: 15px"></v-img>
                        </div>

<!--                        <v-icon :light="isLight" size="80px" class="mt-4 mr-3">mdi-qrcode-scan</v-icon>-->
                      </div>
                      <v-card-text>
                        <p class="text-subtitle-1 font-weight-bold">We use PPG Teslin® Biodegradable Substrate here at <strong><i>findmykit</i></strong> - a durable synthetic paper with some serious green credentials!</p>
                        <p class="text-body-1">All of our 'non-plastic' tags use Teslin substrate.  Teslin is designed to biodegrade when you need it to, breaking down under anaerobic conditions (lack of oxygen) with micro-organisms that can digest such polymers into materials such as carbon dioxide and water. In fact, it's been shown that this material degrades by 7.8% over a period of 74 days with continual degradation as time goes on.</p>
                        <p class="text-body-1">All the quality, longevity, ease of use, heat stability, performance and security remains, as you would expect from one of our products… contributing to environmental commitment at all times.</p>
                      </v-card-text>
                    </v-card>
                  </v-col>
                  <v-col
                      cols="12"
                      sm="12"
                      md="4">
                    <v-card class="product-card equal-height-card">
                      <div class="d-flex flex-no-wrap justify-space-between">
                        <v-card-title class="headline primary--text">Sticky labels</v-card-title>
                        <div>
                          <v-img :src="require('@/assets/square-sticker.jpg')" width="80px" height="80px" style="border-top-right-radius: 15px"></v-img>
                        </div>
                      </div>
                      <v-card-text>
                        <p class="text-subtitle-1 font-weight-bold">As a plastic, polypropylene is an environmentally conscious option that offers a wide range of benefits over other materials.</p>
                        <p class="text-body-1">Made from Polypropylene (PP), our Sticky Label is a quality, recyclable product.</p>
                        <p class="text-body-1">PP is an environmentally conscious option that offers a wide range of benefits over other materials. It is also a better choice than other plastics, since it doesn't release toxins, has a relatively low carbon footprint, and is safe to human health.</p>
                        <p class="text-body-1">PP is recyclable. It can be separated from other plastic types, melted into a liquid, cooled, and turned into pellets, then used to form new plastics. Parts such as ink and adhesive would be contaminants (along with similar materials from the
                          package itself) and removed from the recyling process.</p>
                      </v-card-text>
                    </v-card>
                  </v-col>
                  <v-col
                      cols="12"
                      sm="12"
                      md="4">
                    <v-card class="product-card equal-height-card">
                      <div class="d-flex flex-no-wrap justify-space-between">
                        <v-card-title class="headline primary--text">Iron-on labels</v-card-title>
                        <div>
                          <v-img :src="require('@/assets/square-iron-on.jpg')" width="80px" height="80px" style="border-top-right-radius: 15px"></v-img>
                        </div>
                      </div>
                      <v-card-text>
                        <p class="text-subtitle-1 font-weight-bold">Made from Polyurethane, we have worked hard to find a product not only fit-for-purpose, but one that can offer additional qualities.</p>
                        <p class="text-body-1">In line with our ongoing commitment to improving our products, and further helping the environment, we have recently switched to an 'even more'
                          sustainable material than the current labels we supply.</p>
                        <p class="text-body-1">The 'S-Print' labels will have in the future a water based adhesive.The water based production process has a lower impact on energy consumption, making it more sustainable and environment friendly.
                        </p>
                        <p class="text-body-1"><v-img :src="require('@/assets/oeko.jpg')" width="200" class="float-right ml-3"></v-img> Our labels are tested to OEKO-TEX® Standard 100 which means they have been tested for harmful substances, from yarns to the finished product. </p>
<!--                        <p class="text-body-1">OEKO-TEX® standards enable everyone to make responsible decisions and protect natural resources. Driven by sustainability and a dedication to transparency, their work is grounded in proven science.</p>-->
                      </v-card-text>
                    </v-card>
                  </v-col>
                </v-row>
                <v-row>
                    <v-col
                        cols="12"
                        sm="12"
                        md="6"
                    >
                        <v-card class="product-card equal-height-card">

                            <div class="d-flex flex-no-wrap justify-space-between">
                                <v-card-title class="headline primary--text">{{ $t("The facts") }}</v-card-title>
                                <v-icon :light="isLight" size="100px" class="mt-1">mdi-text-box-check-outline</v-icon>
                            </div>

                            <v-card-text>
                                <p class="text-subtitle-1 font-weight-bold">{{ $t("Did you know that clothing items are amongst the top ten items most commonly lost in both adults and children?") }}</p>
                                <p class="text-body-1">When you then consider how detrimental the fashion industry can be on the environment, any way we can help lessen this would undoubtedly be beneficial. This industry contributes towards the production of greenhouse gases, uses up trillions of litres of water (1.5 trillion each year to be precise) and energy too. Helping you to keep track of all your items with the <strong><i>findmykit</i></strong> system – clothing or otherwise – can reduce the need to buy new items, thus putting less demand on the fashion industry.</p>
                            </v-card-text>
                        </v-card>
                    </v-col>
<!--                    <v-col-->
<!--                        cols="12"-->
<!--                        sm="12"-->
<!--                        md="4">-->
<!--                        <v-card class="product-card equal-height-card">-->
<!--                            <div class="d-flex flex-no-wrap justify-space-between">-->
<!--                                <v-card-title class="headline primary&#45;&#45;text">{{ $t("The products") }}</v-card-title>-->
<!--                                <v-avatar-->
<!--                                        class="mt-3 mr-3"-->
<!--                                        size="80"-->
<!--                                        rounded-->
<!--                                >-->
<!--                                <v-img-->
<!--                                        :src="bioIcon"-->
<!--                                        width="150px"-->
<!--                                ></v-img>-->

<!--                                </v-avatar>-->
<!--                            </div>-->
<!--                            <v-card-text>-->
<!--                                <p class="text-subtitle-1 font-weight-bold">{{ $t("We use PPG Teslin® Biodegradable Substrate here at {brand}* - a durable synthetic paper with some serious green credentials! All the quality, longevity, ease of use, heat stability, performance and security you’d expect from one of our products… whilst remaining environmentally-responsible at all times.", {brand: brandName}) }}</p>-->
<!--                                <p class="text-body-1">{{ $t("This Teslin substrate is designed to biodegrade when you need it to, breaking down under anaerobic conditions (lack of oxygen) with microorganisms that can digest such polymers into materials such as carbon dioxide and water. In fact, it's been shown that this material degrades by 7.8% over a period of 74 days with continual degradation as time goes on. All PPG Teslin® Biodegradable Substrate products have been independently tested to ASTM standard D5511 too, giving you total peace of mind when it comes to purchasing {brand} products.", {brand: brandName}) }}-->
<!--                                    </p>-->
<!--                                <p class="text-caption">*{{ $t("Our iron-on and sticker products are not made of the same material.") }}</p>-->
<!--                            </v-card-text>-->
<!--                        </v-card>-->
<!--                    </v-col>-->
                    <v-col
                            cols="12"
                            sm="12"
                            md="6">
                        <v-card class="product-card equal-height-card">
                            <div class="d-flex flex-no-wrap justify-space-between">
                                <v-card-title class="headline primary--text">{{ $t("The technology") }}</v-card-title>
                                <v-icon :light="isLight" size="80px" class="mt-4 mr-3">mdi-qrcode-scan</v-icon>
                            </div>
                            <v-card-text>
                                <p class="text-subtitle-1 font-weight-bold">When you label your possessions with a <strong><i>Findmykit</i></strong> tag, you can be confident that they’re protected should they ever get lost.</p>
                                <p class="text-body-1">If found, they can then be scanned by a member of our network and the owner alerted via an email or text message. This negates a new item having to be purchased as a replacement – simple! So next time you think of <strong><i>findmykit</i></strong>, remember that being in the pink (just like our logo!) may be greener than you realise.</p>
                            </v-card-text>
                        </v-card>
                    </v-col>
                </v-row>
                <v-row>
                    <v-col>
                        <v-card class="product-card">
                            <v-card-text>
                                <vimeo-player ref="player" :video-id="videoID" @ready="onReady" class="player-container" :options="options">
                                </vimeo-player>
                            </v-card-text>
                        </v-card>
                    </v-col>
                </v-row>
            </v-container>
        </v-container>
        <Footer />
    </div>
</template>

<script>
    import Footer from './Footer.vue'
    import {i18n} from "../i18n";
    import {mapState} from "vuex";
    import VideoBackground from 'vue-responsive-video-background-player'

    export default {
        name: "Environment",
        metaInfo () {
            return {
                title: this.capitalizeFirstLetter(this.brand) + ' - ' + i18n.t('headings.Environment'),
                htmlAttrs: {
                    lang: i18n.locale
                },
                meta: [
                    { name: 'description', content: i18n.t("Here at {brand}, we've created a product that helps to solve a universal problem whilst reducing the environmental impact", {brand: this.brandName}) + '.' }
                ]
            }
        },
        components: {
            'Footer': Footer,
            VideoBackground
        },
        data () {
            return {
                videoID: '410322496',
                options: {'responsive': true, 'dnt': true},
                playerReady: false
            }
        },
        mounted () {
            window.scrollTo(0,0);

            window.prerenderReady = true;
        },
        methods: {
            capitalizeFirstLetter(string) {
              return string.charAt(0).toUpperCase() + string.slice(1);
            },
            onReady() {
                this.playerReady = true
            },
            play() {
                this.$refs.player.play()
            },
            stop() {
                this.$refs.player.stop()
            }
        },
        computed: {
          ...mapState({
            brand: state => state.brand,
            brandName: state => state.brandName
          }),
          isLight() {
            return Boolean(this.brand !== 'neotag')
          },
          bioIcon() {
            if (this.brand === 'neotag') {
              return require('@/assets/bio-icon-dark.png')
            }
            return require('@/assets/bio-icon.png')
          }
        }
    }
</script>

<style lang="scss">
    .product-card {
        border-radius: 15px;
        border: none !important;
    }
    .equal-height-card {
        height: 100%;
    }
    .player-container {
        width: 100% !important;
    }
    video {
      height: 100% !important;
    }
    .h1-overlay {
      @media only screen and (max-width: 599px) {
        font-size: 2.3rem;
        line-height: 3rem;
      }
      @media only screen and (min-width: 600px) {
        font-size: 5rem;
        line-height: 6rem;
      }
    }
</style>
